const RADIUS_OPTIONS = [1, 5, 10];

function RadiusChips({ nearbyRadius, originLabel, setNearbyRadius }) {
  return <div className="flex items-center gap-1" role="group" aria-label={`Distance from ${originLabel}`} data-testid="radius-filter">
    <span className="font-body text-xs font-semibold text-gray-600 mr-1">Within</span>
    <button type="button" onClick={() => setNearbyRadius(null)} className={`toolbar-action ${nearbyRadius ? "" : "bg-navy text-white border-navy"}`} aria-pressed={!nearbyRadius} data-testid="radius-chip-any">Any</button>
    {RADIUS_OPTIONS.map((miles) => <button key={miles} type="button" onClick={() => setNearbyRadius(miles)} className={`toolbar-action ${nearbyRadius === miles ? "bg-navy text-white border-navy" : ""}`} aria-pressed={nearbyRadius === miles} data-testid={`radius-chip-${miles}`}>{miles} mi</button>)}
  </div>;
}

function distanceStatus({ nearbyRadius, nearbyZip, sortBy, userLocation }) {
  if (!userLocation) return null;
  const origin = nearbyZip?.cityLabel?.split(",")[0] || "your location";
  if (nearbyRadius) return `Within ${nearbyRadius} mi of ${origin} · nearest first`;
  if (sortBy === "nearby") return `Nearest to ${origin}`;
  return null;
}

export function ResultsToolbar({
  filteredCount, visibleCount, sortedCount,
  geoStatus, userLocation, nearbyZip, nearbyRadius, setNearbyRadius, requestLocation,
  sortBy, setSortBy, showFavsOnly, setShowFavsOnly,
  detailsFilter, setDetailsFilter,
  hasActiveFilters, clearFilters,
}) {
  return (
    <div className="flex items-end justify-between mb-6 border-b border-slate-200 pb-5 flex-wrap gap-4">
      <div>
        <p className="text-[10px] uppercase tracking-widest text-gray-500 font-body mb-1">Directory results</p>
        <p className="font-heading text-2xl text-navy font-semibold" data-testid="results-count">
          {Number(filteredCount).toLocaleString()} {filteredCount === 1 ? "venue" : "venues"}
        </p>
        {visibleCount < sortedCount && <p className="font-body text-xs text-gray-500 mt-1">Showing {visibleCount} now</p>}
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        {geoStatus !== "granted" && (
          <button onClick={requestLocation} disabled={geoStatus === "loading"} className="toolbar-action" data-testid="near-me-btn">
            {geoStatus === "loading" ? "Finding your location…" : "Sort near me"}
          </button>
        )}
        {userLocation && <RadiusChips nearbyRadius={nearbyRadius} originLabel={nearbyZip?.cityLabel || "your location"} setNearbyRadius={setNearbyRadius} />}
        {distanceStatus({ nearbyRadius, nearbyZip, sortBy, userLocation }) && <span className="toolbar-status" data-testid="distance-sort-status">{distanceStatus({ nearbyRadius, nearbyZip, sortBy, userLocation })}</span>}
        <button onClick={() => setShowFavsOnly(!showFavsOnly)} className={`toolbar-action ${showFavsOnly ? "bg-navy text-white border-navy" : ""}`} data-testid="favorites-filter-btn">{showFavsOnly ? "Showing saved" : "Saved venues"}</button>
        <label className="font-body text-xs font-semibold text-gray-600" htmlFor="directory-details-filter">Details</label>
        <select id="directory-details-filter" value={detailsFilter} onChange={(event) => setDetailsFilter(event.target.value)} className="font-body text-sm bg-white border border-slate-300 rounded-md px-3 py-2.5 text-navy focus:outline-none focus:border-navy" data-testid="details-filter-select">
          <option value="all">All details</option>
          <option value="evidence">Evidence-based</option>
          <option value="pending">Pending review</option>
          <option value="owner">Owner-confirmed</option>
        </select>
        <label className="font-body text-xs font-semibold text-gray-600" htmlFor="directory-sort">Sort</label>
        <select id="directory-sort" value={sortBy} onChange={(event) => { if (event.target.value === "nearby" && !userLocation) requestLocation(); else setSortBy(event.target.value); }} className="font-body text-sm bg-white border border-slate-300 rounded-md px-3 py-2.5 text-navy focus:outline-none focus:border-navy" data-testid="sort-select">
          <option value="default">Recommended</option>
          {userLocation && <option value="nearby">Nearest first</option>}
          <option value="rating">Highest rated</option>
          <option value="grade">Best grade</option>
          <option value="reviews">Most reviews</option>
          <option value="name">Name A–Z</option>
        </select>
        {hasActiveFilters && <button onClick={clearFilters} className="font-body text-sm text-navy underline underline-offset-4 px-2" data-testid="clear-filters-btn">Clear filters</button>}
      </div>
    </div>
  );
}